<template>
  <div>
    <div class="map-page" id="chart-map">
    </div>
    <div class="map-btn">
      <a class="btn-2" href="javascript:;" @click="hideAllcar" v-if="solutionStatus === 40">部分车辆</a><br>
      <a class="btn-1" href="javascript:;" @click="changeColor">显示地名</a><br>
      <a class="btn-3" href="javascript:;" @click="initBMap">&nbsp;初&nbsp;始&nbsp;化&nbsp;</a>
    </div>
    <div class="map-select-week" v-if="solutionStatus > 10 || solutionStatus === 10">
      <el-select v-model="solutionDay" placeholder="选择送货日期" :disabled="solutionStatus > 20">
        <el-option v-for="(item, index) in solutionWeeks" :key="index" :label="item" :value="index">
        </el-option>
      </el-select>
    </div>
    <div style="display:none">
      {{sourceDataType}}
    </div>
  </div>
</template>

<script>
  window.echarts = require('echarts')

  window.myChat = null

  export default {
    data () {
      return {
        loadJs: false,
        first: '0'
      }
    },
    created () {
      this.$store.dispatch('setChatStatus', 0)
    },
    mounted () {
      window.initMap = this.initChar
      let chat = window.echarts.init(document.getElementById('chart-map'))
      window.myChat = chat
      this.$store.dispatch('setChatStatus', 1)
      this.loadBdmapApi()
    },
    computed: {
      sourceDataType: {
        get () {
          return this.$store.getters.sourceDataType
        }
      },
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      solutionDay: {
        get () {
          return this.$store.getters.solutionDay
        },
        set (value) {
          return this.$store.dispatch('setSolutionDay', value)
        }
      },
      solutionWeeks: {
        get () {
          return this.$store.getters.solutionWeeks
        }
      }
    },
    methods: {
      hideAllcar () {
        window.myChat.getOption().legend[1].data.forEach(function (item) {
          window.myChat.dispatchAction({
            type: 'legendToggleSelect',
            name: item
          })
        })
      },
      changeColor () {
        let option = window.myChat.getOption()
        let color = option.bmap[0].mapStyle.styleJson[14].color
        if (color === '#081734') {
          option.bmap[0].mapStyle.styleJson[14].color = '#FFFFFF'
          window.myChat.setOption(option)
        } else {
          option.bmap[0].mapStyle.styleJson[14].color = '#081734'
          window.myChat.setOption(option)
        }
      },
      loadBdmapApi () {
        this.loadJs = true
        let script = document.createElement('script')
        script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMap'
        document.body.appendChild(script)
      },
      initChar () {
        let vm = this
        this.$store.dispatch('initMapOption')
        window.myChat.on('legendselectchanged', function (params) {
          if (params.name.indexOf('车辆') > -1) {
            vm.$store.dispatch('selectMapCarCustomer', {car: params.name, status: params.selected[params.name]})
          }
        })
      },
      initBMap () {
        let option = window.myChat.getOption()
        option.bmap[0].center = [106.54904, 29.5513]
        option.bmap[0].zoom = 12
        window.myChat.setOption(option, true)
      }
    }
  }
</script>
<style lang="less">
  .anchorBL {
    display: none;
  }
  .map-select-week .el-input__inner{
    text-align: center;
    background-color: #f8ac59;
    color:#fff;
    height: 20px;
    font-size: 10px;
    border:  1px solid #f8ac59;
  }
  .map-select-week .el-input.is-disabled .el-input__inner {
    background-color: #f8ac59;
    border:  1px solid #f8ac59;
    color:#fff;
  }
  .map-select-week .el-select .el-input__inner:focus {
    border-color: #f8ac59;
  }
  .map-select-week .el-select .el-input.is-disabled .el-input__inner:focus {
    border-color: #f8ac59;
  }
  .map-select-week .el-select:hover .el-input__inner {
    border-color: #f8ac59;
  }
  .map-select-week .el-select:hover .el-input.is-disabled .el-input__inner {
    border-color: #f8ac59;
  }
  .map-select-week input::-webkit-input-placeholder {
    color: #eee;
  }

</style>
<style scoped lang="less">
  @import '../style/base.less';
  .map-page {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .map-select-week {
    position: absolute;
    top: 48px;
    right: 87px;
    z-index: 1000;
    width: 130px;
  }
  .map-btn {
    text-align: center;
    position: absolute;
    bottom: 20px;
    right: 210px;
    z-index: 1000;
    font-size: 14px;
    line-height: 2.3;
    a {
      color:#fff;
      border-radius: 0.2em;
      font-size: 0.7em;
      padding:0.2em 0.3em;
    }

    .btn-1 {
      background-color: #f8ac59;
    }
    .btn-2 {
      background-color: #1ab394;
    }
    .btn-3 {
      background-color: #9bca63;
    }
  }
</style>



// WEBPACK FOOTER //
// map.vue?1c37a563